import { Navigate, Route, Routes } from 'react-router-dom'
import { RequireAuth } from '../auth/RequireAuth'
import { Layout } from '../components/Layout'
import { LoginPage } from '../pages/Login'
import { AppsPage } from '../pages/Apps'
import { AppDetailPage } from '../pages/AppDetail'
import { SettingsPage } from '../pages/Settings'
import { AnalyticsPage } from '../pages/Analytics'

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<Layout />}>
          <Route path="/" element={<Navigate to="/apps" replace />} />
          <Route path="/apps" element={<AppsPage />} />
          <Route
            path="/apps/:appId"
            element={<AppDetailPage />}
          />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

